import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './ServicesPage.css';

// Import service images
import termiteImg from '../assets/Images/general-pest-control-images/Termites.jpg';
import cockroachImg from '../assets/Images/general-pest-control-images/Cockroach.jpeg';
import rodentImg from '../assets/Images/general-pest-control-images/Rodent.jpeg';
import bedBugImg from '../assets/Images/general-pest-control-images/Bed Bug.jpeg';
import mosquitoImg from '../assets/Images/general-pest-control-images/Mosquito.jpeg';
import antImg from '../assets/Images/general-pest-control-images/Ant.jpg';
import generalPestImg from '../assets/Images/general-pest-control-images/General_Pest_Control.png';
import lizardImg from '../assets/Images/general-pest-control-images/Lizard.jpeg';
import flyImg from '../assets/Images/general-pest-control-images/Fly.jpeg';

// Note: This servicesData array is not currently being used in the rendered component
// as the ServicesSection component below is being used instead
const servicesData = [
  {
    id: 1,
    title: 'Termite Control',
    description: 'Effective solutions to protect your property from destructive termites and ensure long-term prevention.',
    iconClass: 'bi bi-tree',
    link: '/booking' 
  },
  {
    id: 2,
    title: 'Cockroach Control',
    description: 'Targeted treatments to eliminate cockroach populations and sanitize affected areas.',
    iconClass: 'bi bi-bug',
    link: '/booking'
  },
  {
    id: 3,
    title: 'Rodent Control',
    description: 'Safe and effective rodent extermination.',
    iconClass: 'bi bi-mouse',
    link: '/booking'
  },
  {
    id: 4,
    title: 'Bed Bug Treatment',
    description: 'Comprehensive bed bug extermination to restore comfort and peace to your bedrooms.',
    iconClass: 'bi bi-bug-fill',
    link: '/booking'
  },
  {
    id: 5,
    title: 'Mosquito Control',
    description: 'Reduce mosquito populations around your home.',
    iconClass: 'bi bi-droplet-half',
    link: '/booking'
  },
  {
    id: 6,
    title: 'Ant Control',
    description: 'Eliminate ant colonies and prevent reinfestation.',
    iconClass: 'bi bi-dot',
    link: '/booking'
  },
  {
    id: 7,
    title: 'General Pest Control',
    description: 'Comprehensive pest management solutions.',
    iconClass: 'bi bi-shield-check',
    link: '/booking'
  },
  {
    id: 8,
    title: 'Lizard Control',
    description: 'Humane and effective lizard removal services.',
    iconClass: 'bi bi-emoji-expressionless',
    link: '/booking'
  },
  {
    id: 9,
    title: 'Fly Control',
    description: 'Eliminate flies and prevent breeding sites.',
    iconClass: 'bi bi-emoji-dizzy',
    link: '/booking'
  }
];

// Services Section that matches the one on HomePage
const ServicesSection = () => {
  const services = [
    { 
      id: 1, 
      title: 'Termite Control', 
      description: 'Effective solutions to protect your property from destructive termites and ensure long-term prevention.',
      image: termiteImg,
      link: '/booking'
    },
    { 
      id: 2, 
      title: 'Cockroach Control', 
      description: 'Targeted treatments to eliminate cockroach populations and sanitize affected areas.',
      image: cockroachImg,
      link: '/booking'
    },
    { 
      id: 3, 
      title: 'Rodent Control', 
      description: 'Safe and effective rodent extermination.',
      image: rodentImg,
      link: '/booking'
    },
    { 
      id: 4, 
      title: 'Bed Bug Treatment', 
      description: 'Comprehensive bed bug extermination to restore comfort and peace to your bedrooms.',
      image: bedBugImg,
      link: '/booking'
    },
    { 
      id: 5, 
      title: 'Mosquito Control', 
      description: 'Reduce mosquito populations around your home.',
      image: mosquitoImg,
      link: '/booking'
    },
    { 
      id: 6, 
      title: 'Ant Control', 
      description: 'Eliminate ant colonies and prevent reinfestation.',
      image: antImg,
      link: '/booking'
    },
    { 
      id: 7, 
      title: 'General Pest Control', 
      description: 'Comprehensive pest management solutions.',
      image: generalPestImg,
      link: '/booking'
    },
    { 
      id: 8, 
      title: 'Lizard Control', 
      description: 'Humane and effective lizard removal services.',
      image: lizardImg,
      link: '/booking'
    },
    { 
      id: 9, 
      title: 'Fly Control', 
      description: 'Eliminate flies and prevent breeding sites.',
      image: flyImg,
      link: '/booking'
    }
  ];

  return (
    <section className="services-section py-5">
      <div className="container">
        <div className="row g-4">
          {services.map((service, index) => (
            <motion.div 
              className="col-lg-4 col-md-6" 
              key={service.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="card service-card h-100 text-center shadow-sm border-0 hover-shadow transition-all">
                <div className="card-body d-flex flex-column h-100 p-4">
                  <div className="mb-3 d-flex align-items-center justify-content-center flex-grow-1" style={{
                    minHeight: '180px',
                    maxHeight: '200px',
                    width: '100%',
                    overflow: 'hidden',
                    borderRadius: '8px',
                    backgroundColor: '#f8f9fa',
                    padding: '1rem'
                  }}>
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="img-fluid"
                      style={{
                        maxHeight: '100%',
                        maxWidth: '100%',
                        width: 'auto',
                        height: 'auto',
                        objectFit: 'contain',
                        transition: 'transform 0.3s ease-in-out',
                        borderRadius: '4px'
                      }}
                      onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                      onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    />
                  </div>
                  <h5 className="card-title fw-bold mt-3 mb-2">{service.title}</h5>
                  <p className="card-text text-muted mb-3">{service.description}</p>
                  <Link to={service.link} className="btn btn-outline-danger mt-auto">Book Now</Link>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

const ServicesPage = () => {
  const cardVariants = {
    offscreen: {
      y: 50,
      opacity: 0
    },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8
      }
    }
  };

  return (
    <div className="services-page-container py-5">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-center mb-5"
        >
          <h1 className="display-4 fw-bold page-title-services">Our Services</h1>
          <p className="lead text-muted">Tailored pest control solutions for a pest-free environment.</p>
        </motion.div>

        {/* Only keep the top 9 service cards */}
        <ServicesSection />
      </div>
    </div>
  );
};

export default ServicesPage;